exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-6714ab10] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.header .func-tabs[data-v-6714ab10] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n.header .func-tabs .pane[data-v-6714ab10] {\n  margin-right: 48px;\n  color: #6D7075;\n}\n.header .func-tabs .active[data-v-6714ab10] {\n  color: #275FE8;\n}\n.advanced[data-v-6714ab10] {\n  margin: 30px 0 8px 0;\n  font-weight: 600;\n}", ""]);

// exports
